import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from './form'

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'libelle',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Civilité/Forme Juridique')}</strong>,
  type: 'string',
}, {
  header: EurestoI18n.t('commun:Abrégé'),
  id: 'abrege',
  type: 'string',
}, {
  header: EurestoI18n.t('commun:Type'),
  id: 'type',
  type: 'string',
  Cell: (row, i) => (Constants.usefullObjectStatic[Constants.module.CRM + '-' + Constants.donnee.civilite].type.find(o => o.id === row.type) || {}).libelle
}]

export default React.memo(props => <Formulaire defaultObject={{
  type: 1, abrege: undefined, libelle: undefined, code_insee: undefined, actif: 1
}} title={'Civilité'} columnSearch={'id'} form={<Template/>} module={Constants.module.COMMUN} requete={Constants.donnee.civilite} columns={columns}/>)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/Civilite/index.js